<template>
    <el-card>
        <template #header>
            <content-header/>
        </template>
        <el-row type="flex" justify="center">
            <lz-form
                ref="form"
                :get-data="getData"
                :submit="onSubmit"
                :errors.sync="errors"
                :form.sync="form"
                :edit-mode="editMode"
                :rules="rules"
            >
                <el-form-item label="名称" required prop="account">
                    <el-input v-model="form.name"/>
                </el-form-item>
                <el-form-item label="账号" required prop="account">
                    <el-input v-model="form.account"/>
                </el-form-item>
                <el-form-item label="手机号码" required prop="phone">
                    <el-input v-model="form.phone"/>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="form.email"/>
                </el-form-item>
<!--                <el-form-item label="分成比例" required prop="proportion">-->
<!--                    <el-input v-model="form.proportion"/>-->
<!--                </el-form-item>-->
            </lz-form>
        </el-row>
    </el-card>
</template>

<script>
    import LzForm from '@c/LzForm'
    import { editAdminUser, storeAdminUser, updateAdminUser } from '@/api/admin-merchant'
    import { getAdminRoles } from '@/api/admin-roles'
    import { getAreas } from '@/api/area'
    import { getAdminPerms } from '@/api/admin-perms'
    import FormHelper from '@c/LzForm/FormHelper'
    import FilePicker from '@c/FilePicker'
    import _get from 'lodash/get'
    import store from '@/store'
    import { ROLE_ADMIN } from '@/libs/constants'

    export default {
        name: 'Form',
        components: {
            FilePicker,
            LzForm,
        },
        mixins: [
            FormHelper,
        ],
        data() {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'))
                } else {
                    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                    if (reg.test(value)) {
                        callback()
                    } else {
                        return callback(new Error('请输入正确的手机号'))
                    }
                }
            }
            return {
                form: {
                    name: '',
                    account: '',
                    phone: '',
                    proportion: '100',
                    email: '',
                    is_add_mch:'1',
                },
                rules: {
                    phone: [
                        { validator: checkPhone, trigger: 'blur' },
                    ],
                    job_number: [
                        { min: 3, max: 6, message: '长度在 3 到 6个字符', trigger: 'blur' },
                    ],
                },
                errors: {},
                roles: [],
                areas: [],
                permissions: [],
            }
        },
        created() {

        },
        methods: {
            async onSubmit() {
                if (this.editMode) {
                    await updateAdminUser(this.resourceId, this.form)
                } else {
                    await storeAdminUser(this.form)
                }
            },
            async getData() {
                const [
                    { data: roles },
                    { data: areas },
                ] = await Promise.all([
                    getAdminRoles({ all: 1 }),
                    getAreas({ all: 1 }),
                ])

                this.roles = roles
                this.areas = areas
                const userRoles = _get(store, 'state.users.user.roles', [])

                if (userRoles.indexOf(ROLE_ADMIN) !== -1) {
                    // 是超级管理员
                    this.areas.push({ id: 99999, name: '全部' })
                    console.log(this.areas)
                }

                if (this.editMode) {
                    const { data } = await editAdminUser(this.resourceId)
                    this.fillForm(data)
                    if (data.quanbu) {
                        this.form.areas.push(99999)
                    }
                }
            },
        },
    }
</script>
